import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

import { Link } from "react-router-dom";

const Items = (props) => {
  const [visibleItems, setVisibleItems] = useState(false);
  const [formValues, setFormValues] = useState({
    NumberOfItemsPerPage: "",
    NumberOfItemsForSearchSuggestions: "",
    NumberOfItemsPerPageInGrid: "",
    DefaultReorderLevelWhenCreatingItems: "",
    DefaultDaysToExpireWhenCreatingItems: "",
    DefaultNewItemsAsServiceItems: false,
    HighlightLowInventoryItemsInItemsModule: false,
    LimitManualPriceAdjustmentsAndDiscounts: false,
    MaxDiscount: "",
    EnableMarkUpCalculator: false,
    EnableMarginCalculator: false,
    VerifyAgeForProducts: false,
    DefaultAgeToVerify: "",
    AgeVerificationStrictDateFormatCheck: false,
    HideSupplierInItemSearchResult: false,
    HideSupplierFromItemPopup: false,
    EasyItemCloneButton: false,
    UseHTMLEditor: false,
    ShowTemporaryActivatedItems: false,
  });
  const [loading, setLoading] = useState(false);
  const [verifyAgeForProducts, setVerifyAgeForProducts] = useState(false);
  const [comingItems, setcomingItems] = useState(props.visibleItemsChange);

  const handleVerifyAgeForProducts = () => {
    setVerifyAgeForProducts(!verifyAgeForProducts);
  };

  const token = localStorage.getItem("Token");

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (values) => {
    const formArray = [
      {
        AppConfigkey: "NumberOfItemsPerPage",
        AppConfigvalue: values.NumberOfItemsPerPage,
      },
      {
        AppConfigkey: "NumberOfItemsForSearchSuggestions",
        AppConfigvalue: values.NumberOfItemsForSearchSuggestions,
      },
      {
        AppConfigkey: "NumberOfItemsPerPageInGrid",
        AppConfigvalue: values.NumberOfItemsPerPageInGrid,
      },
      {
        AppConfigkey: "DefaultReorderLevelWhenCreatingItems",
        AppConfigvalue: values.DefaultReorderLevelWhenCreatingItems,
      },
      {
        AppConfigkey: "DefaultDaysToExpireWhenCreatingItems",
        AppConfigvalue: values.DefaultDaysToExpireWhenCreatingItems,
      },
      {
        AppConfigkey: "DefaultNewItemsAsServiceItems",
        AppConfigvalue: values.DefaultNewItemsAsServiceItems,
      },
      {
        AppConfigkey: "HighlightLowInventoryItemsInItemsModule",
        AppConfigvalue: values.HighlightLowInventoryItemsInItemsModule,
      },
      {
        AppConfigkey: "LimitManualPriceAdjustmentsAndDiscounts",
        AppConfigvalue: values.LimitManualPriceAdjustmentsAndDiscounts,
      },
      { AppConfigkey: "MaxDiscount", AppConfigvalue: values.MaxDiscount },
      {
        AppConfigkey: "EnableMarkUpCalculator",
        AppConfigvalue: values.EnableMarkUpCalculator,
      },
      {
        AppConfigkey: "EnableMarginCalculator",
        AppConfigvalue: values.EnableMarginCalculator,
      },
      {
        AppConfigkey: "VerifyAgeForProducts",
        AppConfigvalue: values.VerifyAgeForProducts,
      },
      {
        AppConfigkey: "DefaultAgeToVerify",
        AppConfigvalue: values.DefaultAgeToVerify,
      },
      {
        AppConfigkey: "AgeVerificationStrictDateFormatCheck",
        AppConfigvalue: values.AgeVerificationStrictDateFormatCheck,
      },
      {
        AppConfigkey: "HideSupplierInItemSearchResult",
        AppConfigvalue: values.HideSupplierInItemSearchResult,
      },
      {
        AppConfigkey: "HideSupplierFromItemPopup",
        AppConfigvalue: values.HideSupplierFromItemPopup,
      },
      {
        AppConfigkey: "EasyItemCloneButton",
        AppConfigvalue: values.EasyItemCloneButton,
      },
      { AppConfigkey: "UseHTMLEditor", AppConfigvalue: values.UseHTMLEditor },
      { AppConfigkey: "ShowTemporaryActivatedItems", AppConfigvalue: values.ShowTemporaryActivatedItems },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "PAYMENT_TYPES",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=PAYMENT_TYPES`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "NumberOfItemsPerPage") {
            formValues.NumberOfItemsPerPage = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "NumberOfItemsForSearchSuggestions"
          ) {
            formValues.NumberOfItemsForSearchSuggestions = data.AppConfigvalue;
          } else if (data.AppConfigkey === "NumberOfItemsPerPageInGrid") {
            formValues.NumberOfItemsPerPageInGrid = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "DefaultReorderLevelWhenCreatingItems"
          ) {
            formValues.DefaultReorderLevelWhenCreatingItems =
              data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "DefaultDaysToExpireWhenCreatingItems"
          ) {
            formValues.DefaultDaysToExpireWhenCreatingItems =
              data.AppConfigvalue;
          } else if (data.AppConfigkey === "DefaultNewItemsAsServiceItems") {
            formValues.DefaultNewItemsAsServiceItems =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "HighlightLowInventoryItemsInItemsModule"
          ) {
            formValues.HighlightLowInventoryItemsInItemsModule =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "LimitManualPriceAdjustmentsAndDiscounts"
          ) {
            formValues.LimitManualPriceAdjustmentsAndDiscounts =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "MaxDiscount") {
            formValues.MaxDiscount = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EnableMarkUpCalculator") {
            formValues.EnableMarkUpCalculator =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableMarginCalculator") {
            formValues.EnableMarginCalculator =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "VerifyAgeForProducts") {
            if (data.AppConfigvalue === "false") {
              formValues.VerifyAgeForProducts = false;
            } else {
              formValues.VerifyAgeForProducts = true;
              setVerifyAgeForProducts(true);
            }
          } else if (data.AppConfigkey === "DefaultAgeToVerify") {
            formValues.DefaultAgeToVerify = data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "AgeVerificationStrictDateFormatCheck"
          ) {
            formValues.AgeVerificationStrictDateFormatCheck =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSupplierInItemSearchResult") {
            formValues.HideSupplierInItemSearchResult =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideSupplierFromItemPopup") {
            formValues.HideSupplierFromItemPopup =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EasyItemCloneButton") {
            formValues.EasyItemCloneButton =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "UseHTMLEditor") {
            formValues.UseHTMLEditor =
              data.AppConfigvalue === "false" ? false : true;
          }
           else if (data.AppConfigkey === "ShowTemporaryActivatedItems") {
            formValues.ShowTemporaryActivatedItems =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: "Number Of Items Per Page:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="NumberOfItemsPerPage"
                name="NumberOfItemsPerPage"
                onChange={handleChange}
              >
                <option>20</option>
                <option>50</option>
                <option>100</option>
                <option>200</option>
                <option>500</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Number Of Items For Search Suggestions:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="NumberOfItemsForSearchSuggestions"
                name="NumberOfItemsForSearchSuggestions"
                onChange={handleChange}
              >
                <option>20</option>
                <option>50</option>
                <option>100</option>
                <option>200</option>
                <option>500</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Number Of Items Per Page In Grid:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="NumberOfItemsPerPageInGrid"
                name="NumberOfItemsPerPageInGrid"
                onChange={handleChange}
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
                <option>13</option>
                <option>14</option>
                <option>15</option>
                <option>16</option>
                <option>17</option>
                <option>18</option>
                <option>19</option>
                <option>20</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Default Reorder Level When Creating Items:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                type="text"
                className="form-control"
                id="DefaultReorderLevelWhenCreatingItems"
                name="DefaultReorderLevelWhenCreatingItems"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Default Days To Expire When Creating Items:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                type="text"
                className="form-control"
                id="DefaultDaysToExpireWhenCreatingItems"
                name="DefaultDaysToExpireWhenCreatingItems"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Default New Items As Service Items:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="DefaultNewItemsAsServiceItems"
                name="DefaultNewItemsAsServiceItems"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Highlight Low Inventory Items In Items Module:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="HighlightLowInventoryItemsInItemsModule"
                name="HighlightLowInventoryItemsInItemsModule"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Max Discount % :",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                type="text"
                className="form-control"
                id="MaxDiscount"
                name="MaxDiscount"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Mark Up Calculator:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="EnableMarkUpCalculator"
                name="EnableMarkUpCalculator"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Margin Calculator:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="EnableMarginCalculator"
                name="EnableMarginCalculator"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Verify Age For Products:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="VerifyAgeForProducts"
                name="VerifyAgeForProducts"
                onChange={handleChange}
                onInput={handleVerifyAgeForProducts}
              />
            </div>
          </div>
          <div
            className={`form-group row ${
              verifyAgeForProducts === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2">
              Default Age To Verify:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="DefaultAgeToVerify"
                  name="DefaultAgeToVerify"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${
              verifyAgeForProducts === true ? "" : "d-none"
            }`}
          >
            <label className="col-form-label col-lg-2 ">
              Age Verification Strict Date Format Check:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  className="form-check-input"
                  style={{ width: "1.5em", height: "1.5em" }}
                  type="checkbox"
                  id="AgeVerificationStrictDateFormatCheck"
                  name="AgeVerificationStrictDateFormatCheck"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Hide Supplier In Item Search Result:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="HideSupplierInItemSearchResult"
                name="HideSupplierInItemSearchResult"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Hide Supplier From Item Popup:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="HideSupplierFromItemPopup"
                name="HideSupplierFromItemPopup"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Easy Item Clone Button:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="EasyItemCloneButton"
                name="EasyItemCloneButton"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Use HTML Editor (CK Editor):",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="UseHTMLEditor"
                name="UseHTMLEditor"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Temporary Activated Items:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="ShowTemporaryActivatedItems"
                name="ShowTemporaryActivatedItems"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data?.filter((el) => {
    return el?.name?.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleItems(!visibleItems);
                  setcomingItems(!!comingItems);
                }}
              >
                Items
              </CLink>
            </h5>
          </div>
          <CCollapse visible={visibleItems || props.visibleItemsChange}>
            <div className="card-body">
              <Link to="/categories">Manage Categories</Link>
              <br />
              <Link to="/tags">Manage Tags</Link>
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items Per Page:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsPerPage"
                          name="NumberOfItemsPerPage"
                          onChange={handleChange}
                        >
                          <option>20</option>
                          <option>50</option>
                          <option>100</option>
                          <option>200</option>
                          <option>500</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items For Search Suggestions:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsForSearchSuggestions"
                          name="NumberOfItemsForSearchSuggestions"
                          onChange={handleChange}
                        >
                          <option>20</option>
                          <option>50</option>
                          <option>100</option>
                          <option>200</option>
                          <option>500</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items Per Page In Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsPerPageInGrid"
                          name="NumberOfItemsPerPageInGrid"
                          onChange={handleChange}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                          <option>11</option>
                          <option>12</option>
                          <option>13</option>
                          <option>14</option>
                          <option>15</option>
                          <option>16</option>
                          <option>17</option>
                          <option>18</option>
                          <option>19</option>
                          <option>20</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Reorder Level When Creating Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultReorderLevelWhenCreatingItems"
                          name="DefaultReorderLevelWhenCreatingItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Days To Expire When Creating Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultDaysToExpireWhenCreatingItems"
                          name="DefaultDaysToExpireWhenCreatingItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Default New Items As Service Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DefaultNewItemsAsServiceItems"
                          name="DefaultNewItemsAsServiceItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Highlight Low Inventory Items In Items Module:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HighlightLowInventoryItemsInItemsModule"
                          name="HighlightLowInventoryItemsInItemsModule"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Limit Manual Price Adjustments And Discounts:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="LimitManualPriceAdjustmentsAndDiscounts"
                          name="LimitManualPriceAdjustmentsAndDiscounts"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Max Discount % :
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="MaxDiscount"
                          name="MaxDiscount"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Mark Up Calculator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableMarkUpCalculator"
                          name="EnableMarkUpCalculator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Margin Calculator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableMarginCalculator"
                          name="EnableMarginCalculator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Verify Age For Products:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="VerifyAgeForProducts"
                          name="VerifyAgeForProducts"
                          onChange={handleChange}
                          onInput={handleVerifyAgeForProducts}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div
                    className={`form-group row ${verifyAgeForProducts === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Default Age To Verify:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultAgeToVerify"
                          name="DefaultAgeToVerify"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div
                    className={`form-group row ${verifyAgeForProducts === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2 ">
                      Age Verification Strict Date Format Check:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AgeVerificationStrictDateFormatCheck"
                          name="AgeVerificationStrictDateFormatCheck"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier In Item Search Result:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierInItemSearchResult"
                          name="HideSupplierInItemSearchResult"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier From Item Popup:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierFromItemPopup"
                          name="HideSupplierFromItemPopup"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Easy Item Clone Button:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EasyItemCloneButton"
                          name="EasyItemCloneButton"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Use HTML Editor (CK Editor):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="UseHTMLEditor"
                          name="UseHTMLEditor"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleItems(!visibleItems);
                    setcomingItems(!!comingItems);
                  }}
                >
                  Items
                </CLink>
              </h5>
            </div>
            <CCollapse visible={visibleItems || props.visibleItemsChange}>
              <div className="card-body">
                <Link to="/categories">Manage Categories</Link>
                <br />
                <Link to="/tags">Manage Tags</Link>
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "35%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items Per Page:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsPerPage"
                          name="NumberOfItemsPerPage"
                          onChange={handleChange}
                        >
                          <option>20</option>
                          <option>50</option>
                          <option>100</option>
                          <option>200</option>
                          <option>500</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items For Search Suggestions:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsForSearchSuggestions"
                          name="NumberOfItemsForSearchSuggestions"
                          onChange={handleChange}
                        >
                          <option>20</option>
                          <option>50</option>
                          <option>100</option>
                          <option>200</option>
                          <option>500</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Number Of Items Per Page In Grid:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="NumberOfItemsPerPageInGrid"
                          name="NumberOfItemsPerPageInGrid"
                          onChange={handleChange}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                          <option>11</option>
                          <option>12</option>
                          <option>13</option>
                          <option>14</option>
                          <option>15</option>
                          <option>16</option>
                          <option>17</option>
                          <option>18</option>
                          <option>19</option>
                          <option>20</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Reorder Level When Creating Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultReorderLevelWhenCreatingItems"
                          name="DefaultReorderLevelWhenCreatingItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Default Days To Expire When Creating Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultDaysToExpireWhenCreatingItems"
                          name="DefaultDaysToExpireWhenCreatingItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Default New Items As Service Items:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DefaultNewItemsAsServiceItems"
                          name="DefaultNewItemsAsServiceItems"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Highlight Low Inventory Items In Items Module:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HighlightLowInventoryItemsInItemsModule"
                          name="HighlightLowInventoryItemsInItemsModule"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Limit Manual Price Adjustments And Discounts:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="LimitManualPriceAdjustmentsAndDiscounts"
                          name="LimitManualPriceAdjustmentsAndDiscounts"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Max Discount % :
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="MaxDiscount"
                          name="MaxDiscount"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Mark Up Calculator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableMarkUpCalculator"
                          name="EnableMarkUpCalculator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Margin Calculator:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableMarginCalculator"
                          name="EnableMarginCalculator"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Verify Age For Products:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="VerifyAgeForProducts"
                          name="VerifyAgeForProducts"
                          onChange={handleChange}
                          onInput={handleVerifyAgeForProducts}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div
                    className={`form-group row ${verifyAgeForProducts === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2">
                      Default Age To Verify:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          type="text"
                          className="form-control"
                          id="DefaultAgeToVerify"
                          name="DefaultAgeToVerify"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div
                    className={`form-group row ${verifyAgeForProducts === true ? "" : "d-none"
                      }`}
                  >
                    <label className="col-form-label col-lg-2 ">
                      Age Verification Strict Date Format Check:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AgeVerificationStrictDateFormatCheck"
                          name="AgeVerificationStrictDateFormatCheck"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier In Item Search Result:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierInItemSearchResult"
                          name="HideSupplierInItemSearchResult"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Supplier From Item Popup:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideSupplierFromItemPopup"
                          name="HideSupplierFromItemPopup"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Easy Item Clone Button:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EasyItemCloneButton"
                          name="EasyItemCloneButton"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Use HTML Editor (CK Editor):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="UseHTMLEditor"
                          name="UseHTMLEditor"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default Items;
